import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ConnectedTextField from '../../_atomic/ConnectedTextField/ConnectedTextField';

import { TEXT_FIELD_STATUS } from '../../../utils/constants';
import { passwordValidator, passwordConfirmation } from '../../../utils/helpers';
import './PasswordField.scss';

const openedEye = require('./assets/opened-eye.png');
const closedEye = require('./assets/closed-eye.png');

class PasswordField extends Component {
  static propTypes = {
    label: PropTypes.string,
    placeholder: PropTypes.string,
    isRequired: PropTypes.bool,

    hint: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.string.isRequired,
    errorText: PropTypes.string,
    status: PropTypes.string.isRequired,
    isFocused: PropTypes.bool,
    needSpecifiedValidator: PropTypes.bool,
    contextProvider: PropTypes.string,
    needConfirmation: PropTypes.bool,
  };

  static defaultProps = {
    label: 'Password',
    placeholder: 'Password',
    isRequired: false,
    hint: '',
    name: '',
    errorText: '',
    isFocused: false,
    needSpecifiedValidator: false,
    needConfirmation: false,
    contextProvider: '',

  };
  state = {
    showPassword: false,
    specifiedValidator: () => '',
  }

  componentWillMount() {
    const { needConfirmation, needSpecifiedValidator } = this.props;
    let { specifiedValidator } = this.state;
    if (needConfirmation) specifiedValidator = passwordConfirmation;
    if (needSpecifiedValidator) specifiedValidator = passwordValidator;
    this.setState(() => ({
      specifiedValidator,
    }));
  }
  showPasswordToggle = (e) => {
    e.preventDefault();
    this.setState(() => ({
      showPassword: !this.state.showPassword,
    }));
  }


  render() {
    const {
      label,
      placeholder,
      isRequired,
      hint,
      name,
      isFocused,
      status,
      value,
      errorText,

      contextProvider,
    } = this.props;
    const { showPassword, specifiedValidator } = this.state;
    const passwordFieldClasses = classNames({
      'show-password': showPassword,
      'show-password-toggle': isFocused || status !== TEXT_FIELD_STATUS.INITIAL,
      'password-field': true,
    });

    return (
      <ConnectedTextField
        label={label}
        placeholder={placeholder}
        className={passwordFieldClasses}
        type={showPassword
        ? 'text'
        : 'password'}
        hint={hint}
        name={name}
        value={value}
        status={status}
        isFocused={isFocused}
        errorText={errorText}
        isRequired={isRequired}
        contextProvider={contextProvider}
        specifiedValidator={specifiedValidator}
      >
        <button
          type="button"
          className="password-toggle-wrapper"
          onClick={this.showPasswordToggle}
        >
          <img src={openedEye} className="opened-eye" alt="open-eye" />
          <img src={closedEye} className="closed-eye" alt="closed-eye" />
        </button>
      </ConnectedTextField>
    );
  }
}

export default PasswordField;



// WEBPACK FOOTER //
// ./src/components/_molecules/PasswordField/PasswordField.js